export default __webpack_public_path__ + "static/media/logo-black.dfdbda67.svg";